import { createSelector } from 'reselect';

export const getFolderHeader = createSelector(
  state => state.currentFolder.header,
  state => state.entities.partners?.[state.currentFolder.header.client?.clientId],
  (_state, paramDocumentTypeId) => paramDocumentTypeId,
  (header, partner, paramDocumentTypeId) => {
    const { loaded, loading, client, documentTypeId } = header;
    if (!loaded || loading || !client.loaded)
      return {
        ...header,
        documentTypeId: documentTypeId ?? paramDocumentTypeId
      };

    const { partnerId, partnerName, ...folderClient } = partner || {};

    return {
      ...header,
      documentTypeId: documentTypeId ?? paramDocumentTypeId,
      client: {
        ...client,
        clientId: partnerId,
        clientName: partnerName,
        ...folderClient
      }
    };
  }
);

export const getFolderOfferData = state => {
  const { offerId, offerSiteId } = state.currentFolder.header;
  return { offerId, offerSiteId };
};

export const getFolderGeneralInfo = createSelector(
  state => state.currentFolder.generalInfo,
  generalInfo => ({ ...generalInfo })
);
